
function getMonthThai(month) {
  let m = parseInt(month)
  switch(m) {
    case 1: return 'ม.ค.';
    case 2: return 'ก.พ.';
    case 3: return 'มี.ค.';
    case 4: return 'เม.ย.';
    case 5: return 'พ.ค.';
    case 6: return 'มิ.ย.';
    case 7: return 'ก.ค.';
    case 8: return 'ส.ค.';
    case 9: return 'ก.ย.';
    case 10: return 'ต.ค.';
    case 11: return 'พ.ย.';
    case 12: return 'ธ.ค.';
    default: return m;
  }
}

function getYearThai(year) {
  let y = parseInt(year)
  return y+543;
}

function convertEngDateToThai(date) {
  if (date.length === 10){
    let dateArray = date.split("/")
    if (dateArray.length === 3) {
      return parseInt(dateArray[0])+" "+getMonthThai(dateArray[1])+" "+getYearThai(dateArray[2])
    }
  }
}


function convertEngNoDashDateToThai(date) {
  if (date.length === 8){
    const y = date.substring(0, 4)
    const m = date.substring(4, 6)
    const d = date.substring(6, 8)

      return parseInt(d)+" "+getMonthThai(parseInt(m))+" "+getYearThai(y)
    
  }
}

export { convertEngDateToThai, convertEngNoDashDateToThai } 